export class BeeVersionError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class StampError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class DriveError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class SignerError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class FileInfoError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class FileError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class SubscriptionError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class GranteeError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class SendShareMessageError extends Error {
  public constructor(message: string) {
    super(message);
  }
}
